module.exports = __webpack_public_path__ + "assets/discover-7991fc.svg";